import styled from 'styled-components'

import MEDIA from 'constants/media'


import RetailIcon from 'assets/images/icons/locations/RetailLounge.svg'
import MobileLoungeIcon from 'assets/images/icons/locations/MobileLounge.svg'
import KioskIcon from 'assets/images/icons/locations/Kiosk.svg'
import MobileAppIcon from 'assets/images/icons/locations/MobileApp.svg'
import ShopOnlineIcon from 'assets/images/icons/locations/ShopOnline.svg'
import HoursIcon from 'assets/images/icons/locations/Hours.svg'
import AddressIcon from 'assets/images/icons/locations/Address.svg'
import PhoneIcon from 'assets/images/icons/locations/Phone.svg'
import MailIcon from 'assets/images/icons/locations/Envelope.svg'
import WatchIcon from 'assets/images/icons/locations/StopWatch.svg'

import {
  Props,
  Theme,
} from './types'

/* eslint-disable import/prefer-default-export */
export const Icon = styled.span`
  display: inline-block;
  background-size: contain;
  background-position: center bottom;
  background-repeat: no-repeat;
  height: 100px;
  width: 120px;
  margin-bottom: 10px;
  ${MEDIA.medium`
    height: 110px;
    width: 180px;
  `}

  ${(props: Props): string | undefined => (props.theme === Theme.retail && `
    background-image: url(${RetailIcon});
    height: 55px;
    width: 120px;
    ${MEDIA.medium`
      height: 80px;
      width: 180px;
    `}
  `) || (props.theme === Theme.mobile && `
    background-image: url(${MobileLoungeIcon});
    height: 55px;
    width: 120px;
    ${MEDIA.medium`
      height: 80px;
      width: 180px;
    `}
  `) || (props.theme === Theme.kiosk && `
    background-image: url(${KioskIcon});
    height: 100px;
    width: 120px;
    ${MEDIA.medium`
      height: 110px;
      width: 180px;
    `}
  `) || (props.theme === Theme.app && `
    background-image: url(${MobileAppIcon});
    height: 90px;
    width: 120px;
    ${MEDIA.medium`
      height: 110px;
      width: 180px;
    `}
  `) || (props.theme === Theme.shop && `
    background-image: url(${ShopOnlineIcon});
    height: 70px;
    width: 120px;
    ${MEDIA.medium`
      height: 110px;
      width: 180px;
    `}
  `) || (props.theme === Theme.address && `
    background-image: url(${AddressIcon});
    height: 60px;
    width: 60px;
    ${MEDIA.medium`
      height: 90px;
      width: 90px;
    `}
  `) || (props.theme === Theme.phone && `
    background-image: url(${PhoneIcon});
    height: 60px;
    width: 60px;
    ${MEDIA.medium`
      height: 90px;
      width: 90px;
    `}
  `) || (props.theme === Theme.mail && `
    background-image: url(${MailIcon});
    height: 60px;
    width: 60px;
    ${MEDIA.medium`
      height: 90px;
      width: 90px;
    `}
  `) || (props.theme === Theme.hours && `
    background-image: url(${HoursIcon});
    height: 60px;
    width: 60px;
    ${MEDIA.medium`
      height: 90px;
      width: 90px;
    `}
  `) || (props.theme === Theme.watch && `
    background-image: url(${WatchIcon});
    height: 80px;
    width: 80px;
    ${MEDIA.medium`
      height: 110px;
      width: 110px;
    `}
  `) || undefined}
`
